import { render, staticRenderFns } from "./Keynotes.vue?vue&type=template&id=6f7597c2&"
import script from "./Keynotes.vue?vue&type=script&lang=js&"
export * from "./Keynotes.vue?vue&type=script&lang=js&"
import style0 from "./Keynotes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
